function escapeHtmlEntities(text) {
	if (typeof (text) !== 'string') return text;
	var entityTable = {
		60: 'lt', 62: 'gt', 34: 'quot', 38: 'amp', 39: 'apos'
	};
	return text.replace(/[\u00A0-\u2666<>\&'"]/g, function (c) {
		return '&' + (entityTable[c.charCodeAt(0)] || '#' + c.charCodeAt(0)) + ';';
	});
}

function getURLParameterByName(name: string) {
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	var regex = new RegExp('[\\?&]' + name + "=([^&#]*)"),
		results = regex.exec(location.search);
	return results == null ? '' : escapeHtmlEntities(decodeURIComponent(results[1].replace(/\+/g, ' ')));
}

export {
	escapeHtmlEntities,
	getURLParameterByName,
}
